import React, { useEffect, useState } from 'react';
import { Row, Col, Card, CardBody, CardHeader } from 'reactstrap';
const BookingInvoices = () => {
	let [getAllBookinginvoices, setGetAllBookinginvoices] = useState([]);
	return (
		<React.Fragment>
			<Row>
				<Col xl={12}>
					<Card>
						<CardHeader className="bg-primary">
							<div className="d-flex ">
								<div className="flex-grow-1">
									<h4 className="card-title text-white mt-1 font-size-12">
										Booking Invoices ({getAllBookinginvoices?.length})
									</h4>
								</div>
							</div>
						</CardHeader>
						<CardBody></CardBody>
					</Card>
				</Col>
			</Row>
		</React.Fragment>
	);
};

export default BookingInvoices;
